import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=4c7b66c3&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/LoadingSpinner/LoadingSpinner.less?vue&type=style&index=0&id=4c7b66c3&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b66c3",
  null
  
)

export default component.exports